import { MyProfileResponseDto, UseQueryOptionsType } from '@repo/services/hooks';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import http from 'services/http';
import { setUserIdState } from 'store/userIdStore';
import { checkIsLogin } from 'utils/auth';
import { LOADING_KEY, withLoading } from 'utils/promise';

export const MY_PROFILE_KEY: string[] = ['myProfile'];

export function getMyProfile() {
  return http.get<MyProfileResponseDto>(`/my/profile`, {}, { useRedirectAndLogout: false, useLoading: false });
}

export const useGetMyProfile = () => {
  const isCustomLogin = checkIsLogin();

  return useQuery({
    queryKey: MY_PROFILE_KEY,
    queryFn: () => withLoading(LOADING_KEY.PROFILES, getMyProfile),
    enabled: isCustomLogin,
    refetchOnWindowFocus: true, // 이메일 인증 후에 재호출되도록
    onSuccess: (response) => {
      if (response?.id) {
        setUserIdState(response.id);
      }
    },
  });
};

export interface NsfwResponseDto {
  adultVerifiedAt: string;
  enableNsfw: boolean;
  isAdult: boolean;
}

export const useGetEnableNsfw = (options: UseQueryOptionsType<any>) => {
  return useQuery({
    queryKey: ['nsfw'],
    queryFn: () => http.get<NsfwResponseDto>(`/my/enable-nsfw`, {}, { useLoading: false }),
    staleTime: 1000 * 60 * 1,
    cacheTime: 1000 * 60 * 1,
    ...options,
  });
};

export const useUpdateNsfwEnable = (userId?: string) => {
  const queryClient = useQueryClient();

  return useMutation(() => http.put(`/users/${userId}/enable-nsfw/enable`, {}, { useLoading: false }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['nsfw']);
      // queryClient.invalidateQueries(weeklyBannerKeys.openList({ enableNsfw: true }));
    },
  });
};

export const useUpdateNsfwDisable = (userId?: string) => {
  const queryClient = useQueryClient();
  return useMutation(() => http.put(`/users/${userId}/enable-nsfw/disable`, {}, { useLoading: false }), {
    useErrorBoundary: false,
    onSuccess: () => {
      queryClient.invalidateQueries(['nsfw']);
      // queryClient.invalidateQueries(weeklyBannerKeys.openList({ enableNsfw: false }));
    },
  });
};
